import { render, staticRenderFns } from "./PaymentFiles.vue?vue&type=template&id=4fd398c2&scoped=true"
import script from "./PaymentFiles.vue?vue&type=script&lang=ts"
export * from "./PaymentFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd398c2",
  null
  
)

export default component.exports